<template>
        <button
        :type="Type"
        @click.prevent="ButtonFunction"
        class='d-flex justify-content-between'
        >
        <span id='span-button'>Ver carrinho ({{Itens}})</span>
        R${{Valor}}
        </button>
</template>

<script>
    export default {
        props: {
            Type: {
                type: String,
            },
            Valor: {
                type: [String, Number],
            },
            Itens: {
                type: [String,Number],
            },
            ButtonFunction: {
                type: Function,
            },

        },
    }
</script>

<style lang="css" scoped>
button {
    background-color: var(--main-red-black);
    border-radius: 0.375rem;
    color: var(--main-white);
    font-size: 1.1857rem;
    font-weight: bold;
    padding: .6rem 1rem;
    margin: auto;
    width: 90%;
    
}

  @media (min-width: 1400px) and (max-width: 2600px) {

  }
</style>